/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Store } from 'redux';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IApplicationState } from '../../../../shared/types/redux';

interface IDependencies {
  app: JSX.Element;
  store: Store<IApplicationState>;
  cb(): void;
  rootElement: HTMLElement;
}

export function renderReactApp({ cb, store, app, rootElement }: IDependencies) {
  ReactDOM.render(
    //tslint:disable-next-line:no-any
    <Provider store={store as any}>{app}</Provider>,
    rootElement,
    cb,
  );
}
